@let icon = iconName();
<div class="label-location {{ COLORS_MAP[color()] }} {{ SIZES_MAP[size()] }}">
  <span>
    <ng-content></ng-content>
  </span>

  @if (icon) {
    <fr8bot-ui-icon [name]="icon" [size]="16" />
  }
</div>
